import { useEffect, useState } from "react";
import { GeoJSON, ImageOverlay, Pane } from "react-leaflet";
import { api, API } from "@/lib/api";
import { featureInfo } from "@/lib/featureInfo";

function VectorLayer({ layer, pane, onSelect }) {
  const [data, setData] = useState(null);
  useEffect(() => { if (layer.geojson) { setData(layer.geojson); return; } api.get(`/map/layers/${layer.id}/geojson`).then(({ data: d }) => setData(d)).catch(() => {}); }, [layer.id, layer.geojson]);
  if (!data) return null;
  const style = () => ({ color: layer.color, weight: 2, fillColor: layer.color, fillOpacity: layer.opacity ?? 0.45, opacity: 0.95 });
  const f = layer.filter;
  const filterFn = (feat) => !f?.field || f.value == null || String(feat.properties?.[f.field] ?? "") === f.value;
  return (
    <GeoJSON key={`${layer.id}-${layer.color}-${layer.opacity}-${f?.field}-${f?.value}`} data={data} style={style} pane={pane} filter={filterFn}
      pointToLayer={(f, latlng) => window.L.circleMarker(latlng, { radius: 6, pane, ...style() })}
      onEachFeature={(f, l) => {
        l.on("click", (e) => { if (window.__cglandMeasuring) return; window.L.DomEvent.stopPropagation(e); onSelect?.(featureInfo(layer, f, e.latlng)); });
        l.on("mouseover", () => l.setStyle?.({ weight: 3, fillOpacity: Math.min((layer.opacity ?? 0.45) + 0.2, 0.9) }));
        l.on("mouseout", () => l.setStyle?.(style()));
      }} />
  );
}

function RasterLayer({ layer, pane }) {
  const token = localStorage.getItem("cgland_token");
  return <ImageOverlay url={`${API}/map/layers/${layer.id}/overlay.png?auth=${token}`} bounds={layer.bounds} opacity={layer.opacity ?? 0.5} pane={pane} />;
}

// Layers arrive bottom-first; each gets its own pane so stacking follows the superadmin's order.
export function UploadedLayers({ layers, onSelect }) {
  return (
    <>
      {layers.map((l, idx) => {
        const pane = `layer-${l.id}`;
        return (
          <Pane key={`${l.id}-${idx}`} name={pane} style={{ zIndex: 401 + idx }}>
            {l.kind === "raster" ? <RasterLayer layer={l} pane={pane} /> : <VectorLayer layer={l} pane={pane} onSelect={onSelect} />}
          </Pane>
        );
      })}
    </>
  );
}
